import { useRouteContext } from "@tanstack/react-router";

import type { AppInfo } from "@/openapi";

/**
 * Reads capabilities from the active protected-route context without importing its
 * module, avoiding circular route-tree initialization. Must be used beneath
 * `/_protected`, whose loader provides the capabilities.
 */
export const useAppCapabilities = (): AppInfo =>
  useRouteContext({
    from: "/_protected",
    select: (ctx) => ctx.appInfo,
  });
